import { FC, ButtonHTMLAttributes, ReactNode } from 'react'
import { useTheme } from '@emotion/react'

// styles
import { styles } from './styles'

interface ButtonLargeProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  primary?: boolean
  children: ReactNode

  appearance?: 'primary' | 'secondary'
}

export const ButtonLarge: FC<ButtonLargeProps> = ({
  appearance = 'primary',
  children,
  ...attributes
}) => {
  const theme = useTheme()

  return (
    <button
      css={[
        styles(theme).button.main,
        appearance === 'primary' && styles(theme).button.primary,
        appearance === 'secondary' && styles(theme).button.secondary,
        attributes.disabled && styles(theme).button.disabled,
      ]}
      type="button"
      {...attributes}
    >
      <div css={styles(theme).button.content.main}>
        <div css={styles(theme).button.content.children}>{children}</div>
      </div>
    </button>
  )
}

ButtonLarge.propTypes = {}
